<template>
  <div class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson px2 mb2">
      <div class="col-12 px2">
        <div class="clearfix border muted-border p2 shadow" v-if="showMobile">
          <div class="col-12 px2 pt3">
            <p class="h4 semi-bold line-height-2 my2">Autopilot (integrationer)</p>
            <p class="h5 regular darkblue line-height-golden mb3">
              <span class="primarycolor block mb1">Spar tid med autopiloter</span>
              Få dine systemer til at “snakke sammen”. Det sparer dig tid, sikrer flere anbefalinger og skaber opmærksomhed om din virksomhed.
            </p>
            <b-img src="static/img/photo1.png" alt="" fluid-grow></b-img>
          </div>
          <div class="col-12 px2 pt3">
            <p class="h5 regular darkblue line-height-golden mb3">
              <span class="primarycolor block mb1">Regnskabs-autopilot</span>
              Med autopiloten får du hver uge en SMS med dine kunder, hvor du hurtigt kan invitere dem til at skrive en anbefaling af din virksomhed. Hvis du vil gøre det selv, tryk på dit regnskabsprogram:
            </p>
            <p class="h5 regular darkblue line-height-golden mb3">
              <span class="semi-bold block">Data og fortrolighed</span>
              Din data bliver selvfølgelige behandlet fortroligt i henhold til vores databehandleraftale, og bliver alene brugt til at indhente dine anbefalinger samt statistikker, som du løbende vil modtage i fremtiden.
            </p>
          </div>
          <!-- dinero -->
          <div class="col-12 px0">
            <div v-if="haaId !== '0'">
              <div class="clearfix mb2">
                <div class="col-12 px2 py2 flex justify-between items-center">
                  <div @click="getdataigibility('dinero', 'no')" v-b-toggle.details1 class="pointer flex justify-start items-center">
                    <img src="static/svg/dinero1.svg" width="100%">
                  </div>
                  <button class="outlined-dark-button gibson h6 px2 py1" v-if="help !== ''">
                    <span>Hjælp</span>
                  </button>
                </div>
              </div>
              <div class="clearfix">
                <div class="col-12 px2">
                  <b-collapse id="details1" class="">
                    <p class="h semi-bold line-height-2 my2">Indsæt API-nøglen fra Dinero herunder.</p>
                    <div show v-if="dineroapiupdate !== ''" class="clearfix darkblue-background white p2 mb2">
                      <p class="h5 gibson regular line-height-golden">
                        <span class="semi-bold block mb2">Tak! Din konto hos Dinero er nu integreret med Håndværker.dk.</span>
                        Du vil få en SMS hver uge med dine kunder fra Dinero, hvor du kan invitere dem til at skrive en anbefaling om din virksomhed.
                      </p>
                    </div>
                    <div class="">
                      <button type="button" class="col-12 outlined-primary-button my1 p2 h5 flex justify-center items-center line-height-1 gibson" @click="showModal('Dinero_vejledning.pdf')">
                        <span class="mr2 semi-bold">Hent vejledning her</span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                      <button type="button" class="col-12 outlined-primary-button my2 p2 h5 flex justify-center items-center line-height-1 gibson" @click="openUrl('https://www.youtube.com/watch?v=kbznMBh-LTs&feature=youtu.be')" >
                        <span class="semi-bold mr2">Se video-vejledning</span>
                        <span><i class="el-icon-right"></i></span>
                      </button>
                      <button type="button" class="col-12 outlined-primary-button my1 p2 h5 flex justify-center items-center line-height-1 gibson" @click="openUrl('https://dinero.dk/')" >
                        <span class="semi-bold pr2">Åbn link til Dinero</span>
                        <span><i class="el-icon-right"></i></span>
                      </button>
                    </div>
                    <div class="py2"></div>
                    <form @submit.stop.prevent="getdataigibility('dinero', 'no')">
                      <b-form-group id="nameInput" label="API-nøgle" label-for="navn" class="h6 darkblue regular gibson">
                        <b-form-input id="navn" type="text" v-model="apikey" required placeholder="" class="muted-background px2 py1 border-none darkblue h6 not-rounded" autocomplete="off"></b-form-input>
                        <b-form-text id="password-help-block" class="h6 darkblue regular gibson" style="font-size:11.5px;">
                          Indsæt venligst en gyldig API-nøgle
                        </b-form-text>
                      </b-form-group>
                      <b-form-group id="emailInput" label="Firma ID" label-for="email" class="h6 darkblue regular gibson">
                        <b-form-input id="email" type="number" v-model="firmaid" required placeholder="" class="muted-background px2 py1 border-none darkblue h6 not-rounded" autocomplete="off"></b-form-input>
                        <b-form-text id="password-help-block" class="h6 darkblue regular gibson" style="font-size:11.5px;">
                          Indsæt venligst et gyldigt firma ID
                        </b-form-text>
                      </b-form-group>
                      <button type="submit" class="col-12 action-button p2 h5 semi-bold not-rounded border-none gibson line-height-1">
                        <span class="semi-bold pr2">Gem</span>
                        <span><i class="el-icon-right"></i></span>
                      </button>
                      <div v-if="dineroapiupdate !== ''">
                        <b-alert size="lg" show variant="secondary">
                          <span>Sidste opdatering</span>:
                          <span>{{ moment(dineroapiupdate).locale('da').format('LL') }}</span>
                        </b-alert>
                      </div>
                    </form>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
          <!-- economic -->
          <div class="col-12 px0">
            <div v-if="haaId !== '0'">
              <div class="clearfix mb2">
                <div class="col-12 px2 py2 flex justify-between items-center">
                  <div @click="getdataigibility('economic', 'no')" v-b-toggle.details2 class="pointer flex justify-start items-center">
                    <img src="static/svg/visma1.svg" width="100%">
                  </div>
                  <button class="outlined-dark-button gibson h6 px2 py1" v-if="help !== ''">
                    <span>Hjælp</span>
                  </button>
                </div>
              </div>
              <div class="clearfix">
                <div class="col-12 px2">
                  <b-collapse id="details2">
                    <p class="h semi-bold line-height-2 my2">Indsæt ID'et herunder.</p>
                    <div show v-if="economicapiupdate !== ''" class="clearfix darkblue-background white p2 mb2">
                      <p class="h5 gibson regular line-height-golden">
                        <span class="semi-bold block mb2">Tak! Din konto hos e-conomic er nu integreret med Håndværker.dk.</span>
                        Du vil få en SMS hver uge med dine kunder fra e-conomic, hvor du kan invitere dem til at skrive en anbefaling om din virksomhed.
                      </p>
                    </div>
                    <div class="">
                      <button class="col-12 outlined-primary-button my1 p2 h5 flex justify-center items-center line-height-1 gibson" @click="showModal('Economic_vejledning.pdf')">
                        <span class="pr2 semi-bold">Hent vejledning her</span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                      <button class="col-12 outlined-primary-button p2 my1 h5 gibson flex justify-center items-center line-height-1" @click="openUrl('https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=WZr2juvCWXAt4gMuou0RTXvMR0BNFpfJHsnq3M2MQbw1')" >
                        <span class="pr2 semi-bold">Åbn link til E-conomic</span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                    </div>
                    <b-form class="py2" @submit.stop.prevent="getdataigibility('economic', 'no')">
                      <b-form-group id="nameInput" label="ID" label-for="navn">
                        <b-form-input id="navn" type="text" v-model="apikeye" required placeholder="" class="muted-background px2 py1 border-none darkblue h6 not-rounded" autocomplete="off"></b-form-input>
                        <b-form-text id="password-help-block" class="h6 darkblue regular gibson" style="font-size:11.5px;">
                          Indsæt venligst et gyldigt ID
                        </b-form-text>
                      </b-form-group>
                      <div class="clearfix">
                        <button type="submit" class="col-12 action-button p2 my2 h4 flex justify-center items-center line-height-1 semi-bold not-rounded border-none">
                          <span class="pr2 semi-bold">Gem</span>
                          <span>
                            <i class="el-icon-right"></i>
                          </span>
                        </button>
                      </div>
                      <div class="clearfix" v-if="economicapiupdate !== ''">
                        <b-alert size="lg" show variant="secondary">
                          <span>Sidste opdatering</span>:
                          <span>{{ moment(economicapiupdate).locale('da').format('LL') }}</span>
                        </b-alert>
                      </div>
                    </b-form>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
          <!-- billy -->
          <div class="col-12 px0">
            <div v-if="haaId !== '0'">
              <div class="clearfix mb2">
                <div class="col-12 px2 py2 flex justify-between items-center">
                  <div @click="getdataigibility('billy', 'no')" v-b-toggle.details3 class="pointer flex justify-start items-center">
                    <img src="static/svg/billy1.svg" width="100%">
                  </div>
                  <button class="outlined-dark-button gibson h6 px2 py1" v-if="help !== ''">
                    <span>Hjælp</span>
                  </button>
                </div>
              </div>
              <div class="clearfix">
                <div class="col-12 px2">
                  <b-collapse id="details3">
                    <p class="h semi-bold line-height-2 my2">Indsæt ID'et herunder.</p>
                    <div show v-if="billyapiupdate !== ''" class="clearfix darkblue-background white p2 mb2">
                      <p class="h5 gibson regular line-height-golden">
                        <span class="semi-bold block mb2">Tak! Din konto hos billy er nu integreret med Håndværker.dk.</span>
                        Du vil få en SMS hver uge med dine kunder fra Billy, hvor du kan invitere dem til at skrive en anbefaling om din virksomhed.
                      </p>
                    </div>
                    <div class="">
                      <button class="col-12 outlined-primary-button p2 my1 gibson line-height-1 not-rounded" @click="showModal('Billy_vejledning.pdf')">
                        <span class="pr2 semi-bold">Hent vejledning her</span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                      <button class="col-12 outlined-primary-button p2 my1 gibson line-height-1 not-rounded" @click="openUrl('https://www.billy.dk/')" >
                        <span class="pr2 semi-bold">Åbn link til Billy</span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                    </div>
                    <b-form class="py2"  @submit.stop.prevent="getdataigibility('billy', 'no')">
                      <b-form-group id="nameInput"  label="API-nøgle" label-for="navn">
                        <b-form-input id="navn" type="text" v-model="apikeyb" required placeholder="" class="muted-background px2 py1 border-none darkblue h6 not-rounded" autocomplete="off"></b-form-input>
                        <b-form-text id="password-help-block" class="h6 darkblue regular gibson" style="font-size:11.5px;">
                          Indsæt venligst en gyldig API-nøgle
                        </b-form-text>
                      </b-form-group>
                      <div class="clearfix">
                        <button type="submit" class="col-12 my2 action-button p2 h4 semi-bold not-rounded border-none">
                          <span class="pr2 semi-bold">Gem</span>
                          <span>
                            <i class="el-icon-right"></i>
                          </span>
                        </button>
                      </div>
                      <div class="clearfix" v-if="billyapiupdate !== ''">
                        <b-alert size="lg" show variant="secondary">
                          <span>Sidste opdatering</span>:
                          <span>{{ moment(billyapiupdate).locale('da').format('LL') }}</span>
                        </b-alert>
                      </div>
                    </b-form>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 px2 pt3">
            <p class="h5 regular darkblue line-height-golden mb3">
              <span class="primarycolor block mb1">Facebook integration</span>
              Med denne Facebook-integration bliver dine 4- og 5-stjernede anbefalinger automatisk postet på din Facebookside.
            </p>
            <b-img src="static/img/photo2.jpg" fluid-grow></b-img>
          </div>
          <!-- facebook -->
          <div class="col-12 px0">
            <div v-if="haaId !== '0'">
              <div class="clearfix mb2">
                <div class="col-12 px2 py2 flex justify-between items-center">
                  <div v-b-toggle.details4 class="pointer flex justify-start items-center">
                    <img src="static/svg/facebook.svg" width="48">
                  </div>
                  <button class="outlined-dark-button gibson h6 px2 py1" v-if="help !== ''">
                    <span>Hjælp</span>
                  </button>
                </div>
              </div>
              <div class="clearfix">
                <div class="col-12 px2">
                  <b-collapse visible id="details4">
                    <p class="h semi-bold line-height-2 my2">Facebook Integration</p>
                    <div show v-if="facebookapiupdate !== ''" class="clearfix darkblue-background white p2 mb2">
                      <p class="h5 gibson regular line-height-golden">
                        <span class="semi-bold block mb2">Tak! Din Facebook-konto er nu integreret med Håndværker.dk.</span>
                        Vi poster automatisk dine 4- og 5-stjernede anbefalinger på din Facebookside eller profil.
                      </p>
                    </div>
                    <div class="my2">t
                      <button class="col-12 outlined-primary-button p2 gibson flex justify-center items-center line-height-1" @click="showModal('htps://www.haandvaerker.dk/pdf/fb_integration.pdf#zoom=100')">
                        <span class="pr2 semi-bold">Hent vejledning her</span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                    </div>
                    <b-form class="py2" @submit.stop.prevent="service_facebook">
                      <b-form-group id="nameInput" label="Facebook Page-ID" label-for="navn">
                        <b-form-input id="navn" type="text" v-model="facebookpageid" required placeholder="" class="muted-background px2 py1 border-none darkblue h6 not-rounded" autocomplete="off"></b-form-input>
                      </b-form-group>
                      <div class="clearfix">
                        <b-button type="submit" @click="getdataigibilityfb('facebook','yes','https://www.kundematch.dk/newpartner/facebook.php?id='+salesPerson+'&levid='+haaId+'&pageid='+facebookpageid)" class="col-12 facebook-button p2 h6 semi-bold not-rounded border-none">
                          <span class="fab fa-facebook mr-2"></span>
                          <span>Tilknyt Facebook</span>
                        </b-button>
                      </div>
                      <div class="clearfix" v-if="billyapiupdate !== ''">
                        <b-alert size="lg" show variant="secondary">
                          <span>Sidste opdatering</span>:
                          <span>{{ moment(billyapiupdate).locale('da').format('LL') }}</span>
                        </b-alert>
                      </div>
                    </b-form>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8 p2 pl4" v-if="!showMobile">
          <div class="px2 pt3">
            <p class="h4 semi-bold line-height-2 my2">Autopilot (integrationer)</p>
            <p class="h5 regular darkblue line-height-golden mb3">
              <span class="primarycolor block mb1">Spar tid med autopiloter</span>
              Få dine systemer til at “snakke sammen”. Det sparer dig tid, sikrer flere anbefalinger og skaber opmærksomhed om din virksomhed.
            </p>
            <b-img src="static/img/photo1.png" alt="" fluid-grow></b-img>
            <p class="h5 regular darkblue line-height-golden mb3">
              <span class="primarycolor block mb1">Regnskabs-autopilot</span>
              Med autopiloten får du hver uge en SMS med dine kunder, hvor du hurtigt kan invitere dem til at skrive en anbefaling af din virksomhed. Hvis du vil gøre det selv, tryk på dit regnskabsprogram:
            </p>
            <p class="h5 regular darkblue line-height-golden mb3">
              <span class="semi-bold block">Data og fortrolighed</span>
              Din data bliver selvfølgelige behandlet fortroligt i henhold til vores databehandleraftale, og bliver alene brugt til at indhente dine anbefalinger samt statistikker, som du løbende vil modtage i fremtiden.
            </p>
          </div>
        <!-- dinero - economic - billy -->
        <div class="col-8 flex flex-column ml4" role="tablist">
          <!-- dinero -->
          <div class="border muted-border shadow p2 flex mb2 justify-start items-center">
            <div v-if="haaId !== '0'">
              <div class="clearfix">
                <div class="col-12 flex justify-start items-center">
                  <div @click="getdataigibility('dinero', 'no')" v-b-toggle.details1 class="pointer flex justify-start items-center">
                    <img src="static/svg/dinero1.svg" width="100%">
                  </div>
                  <button class="outlined-dark-button gibson h6 px2 py1" v-if="help !== ''">
                    <span>Hjælp</span>
                  </button>
                </div>
              </div>
              <div class="clearfix">
                <div class="col-12 px2">
                  <b-collapse id="details1" class="">
                    <p class="h semi-bold line-height-2 my2">Indsæt API-nøglen fra Dinero herunder.</p>
                    <div show v-if="dineroapiupdate !== ''" class="clearfix darkblue-background white p2 mb2">
                      <p class="h5 gibson regular line-height-golden">
                        <span class="semi-bold block mb2">Tak! Din konto hos Dinero er nu integreret med Håndværker.dk.</span>
                        Du vil få en SMS hver uge med dine kunder fra Dinero, hvor du kan invitere dem til at skrive en anbefaling om din virksomhed.
                      </p>
                    </div>
                    <div class="">
                      <button class="col-12 outlined-primary-button my1 p2 h5 flex justify-center items-center line-height-1 gibson" @click="showModal('Dinero_vejledning.pdf')">
                        <span class="mr2 semi-bold">Hent vejledning her</span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                      <button class="col-12 outlined-primary-button my2 p2 h5 flex justify-center items-center line-height-1 gibson" @click="openUrl('https://www.youtube.com/watch?v=kbznMBh-LTs&feature=youtu.be')">
                        <span class="semi-bold mr2">Se video-vejledning</span>
                        <span><i class="el-icon-right"></i></span>
                      </button>
                      <button class="col-12 outlined-primary-button my1 p2 h5 flex justify-center items-center line-height-1 gibson" @click="openUrl('https://dinero.dk/')">
                        <span class="semi-bold pr2">Åbn link til Dinero</span>
                        <span><i class="el-icon-right"></i></span>
                      </button>
                    </div>
                    <div class="py2"></div>
                    <form @submit.stop.prevent="getdataigibility('dinero')">
                      <b-form-group id="nameInput" label="API-nøgle" label-for="navn" class="h6 darkblue regular gibson">
                        <b-form-input id="navn" type="text" v-model="apikey" required placeholder="" class="muted-background px2 py1 border-none darkblue h6 not-rounded" autocomplete="off"></b-form-input>
                        <b-form-text id="password-help-block" class="h6 darkblue regular gibson" style="font-size:11.5px;">
                          Indsæt venligst en gyldig API-nøgle
                        </b-form-text>
                      </b-form-group>
                      <b-form-group id="emailInput" label="Firma ID" label-for="email" class="h6 darkblue regular gibson">
                        <b-form-input id="email" type="number" v-model="firmaid" required placeholder="" class="muted-background px2 py1 border-none darkblue h6 not-rounded" autocomplete="off"></b-form-input>
                        <b-form-text id="password-help-block" class="h6 darkblue regular gibson" style="font-size:11.5px;">
                          Indsæt venligst et gyldigt firma ID
                        </b-form-text>
                      </b-form-group>
                      <button type="submit" class="col-12 action-button p2 h5 semi-bold not-rounded border-none gibson line-height-1">
                        <span class="semi-bold pr2">Gem</span>
                        <span><i class="el-icon-right"></i></span>
                      </button>
                      <div v-if="dineroapiupdate !== ''">
                        <b-alert size="lg" show variant="secondary">
                          <span>Sidste opdatering</span>:
                          <span>{{ moment(dineroapiupdate).locale('da').format('LL') }}</span>
                        </b-alert>
                      </div>
                    </form>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
          <!-- economic -->
          <div class="border muted-border shadow p2 flex mb2 justify-start items-center">
            <div v-if="haaId !== '0'">
              <div class="clearfix">
                <div class="col-12 flex justify-start items-center">
                  <div @click="getdataigibility('economic', 'no')" v-b-toggle.details2 class="pointer flex justify-start items-center">
                    <img src="static/svg/visma1.svg" width="100%">
                  </div>
                  <button class="outlined-dark-button gibson h6 px2 py1" v-if="help !== ''">
                    <span>Hjælp</span>
                  </button>
                </div>
              </div>
              <div class="clearfix">
                <div class="col-12 px2">
                  <b-collapse id="details2">
                    <p class="h semi-bold line-height-2 my2">Indsæt ID'et herunder.</p>
                    <div show v-if="economicapiupdate !== ''" class="clearfix darkblue-background white p2 mb2">
                      <p class="h5 gibson regular line-height-golden">
                        <span class="semi-bold block mb2">Tak! Din konto hos e-conomic er nu integreret med Håndværker.dk.</span>
                        Du vil få en SMS hver uge med dine kunder fra e-conomic, hvor du kan invitere dem til at skrive en anbefaling om din virksomhed.
                      </p>
                    </div>
                    <div class="">
                      <button class="col-12 outlined-primary-button my1 p2 h5 flex justify-center items-center line-height-1 gibson" @click="showModal('Economic_vejledning.pdf')">
                        <span class="pr2 semi-bold">Hent vejledning her</span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                      <button class="col-12 outlined-primary-button p2 my1 h5 gibson flex justify-center items-center line-height-1" @click="openUrl('https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=WZr2juvCWXAt4gMuou0RTXvMR0BNFpfJHsnq3M2MQbw1')">
                        <span class="pr2 semi-bold">Åbn link til E-conomic</span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                    </div>
                    <b-form class="py2" @submit.stop.prevent="getdataigibility('economic')">
                      <b-form-group id="nameInput" label="ID" label-for="navn">
                        <b-form-input id="navn" type="text" v-model="apikeye" required placeholder="" class="muted-background px2 py1 border-none darkblue h6 not-rounded" autocomplete="off"></b-form-input>
                        <b-form-text id="password-help-block" class="h6 darkblue regular gibson" style="font-size:11.5px;">
                          Indsæt venligst et gyldigt ID
                        </b-form-text>
                      </b-form-group>
                      <div class="clearfix">
                        <button type="submit" class="col-12 action-button p2 my2 h4 flex justify-center items-center line-height-1 semi-bold not-rounded border-none">
                          <span class="pr2 semi-bold">Gem</span>
                          <span>
                            <i class="el-icon-right"></i>
                          </span>
                        </button>
                      </div>
                      <div class="clearfix" v-if="economicapiupdate !== ''">
                        <b-alert size="lg" show variant="secondary">
                          <span>Sidste opdatering</span>:
                          <span>{{ moment(economicapiupdate).locale('da').format('LL') }}</span>
                        </b-alert>
                      </div>
                    </b-form>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
          <!-- billy -->
          <div class="bo1der muted-border shadow p2 flex mb2 justify-start items-center">
            <div v-if="haaId !== '0'">
              <div class="clearfix">
                <div class="col-12 flex justify-start items-center">
                  <div @click="getdataigibility('billy', 'no')" v-b-toggle.details3 class="pointer flex justify-start items-center">
                    <img src="static/svg/billy1.svg" width="100%">
                  </div>
                  <button class="outlined-dark-button gibson h6 px2 py1" v-if="help !== ''">
                    <span>Hjælp</span>
                  </button>
                </div>
              </div>
              <div class="clearfix">
                <div class="col-12 px2">
                  <b-collapse id="details3" class="col-12">
                    <p class="h semi-bold line-height-2 my2">Indsæt ID'et herunder.</p>
                    <div show v-if="billyapiupdate !== ''" class="clearfix darkblue-background white p2 mb2">
                      <p class="h5 gibson regular line-height-golden">
                        <span class="semi-bold block mb2">Tak! Din konto hos billy er nu integreret med Håndværker.dk.</span>
                        Du vil få en SMS hver uge med dine kunder fra Billy, hvor du kan invitere dem til at skrive en anbefaling om din virksomhed.
                      </p>
                    </div>
                    <div class="">
                      <button class="col-12 outlined-primary-button p2 my1 gibson line-height-1 not-rounded" @click="showModal('static/pdf/Integrate Billy_with_Håndværker.dk.pdf')">
                        <span class="pr2 semi-bold">Hent vejledning her</span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                      <button class="col-12 outlined-primary-button p2 my1 gibson line-height-1 not-rounded" @click="openUrl('https://www.billy.dk/')">
                        <span class="pr2 semi-bold">Åbn link til Billy</span>
                        <span>
                          <i class="el-icon-right"></i>
                        </span>
                      </button>
                    </div>
                    <b-form class="py2"  @submit.stop.prevent="getdataigibility('billy')">
                      <b-form-group id="nameInput"  label="API-nøgle" label-for="navn">
                        <b-form-input id="navn" type="text" v-model="apikeyb" required placeholder="" class="muted-background px2 py1 border-none darkblue h6 not-rounded" autocomplete="off"></b-form-input>
                        <b-form-text id="password-help-block" class="h6 darkblue regular gibson" style="font-size:11.5px;">
                          Indsæt venligst en gyldig API-nøgle
                        </b-form-text>
                      </b-form-group>
                      <div class="clearfix">
                        <button type="submit" class="col-12 my2 action-button p2 h4 semi-bold not-rounded border-none">
                          <span class="pr2 semi-bold">Gem</span>
                          <span>
                            <i class="el-icon-right"></i>
                          </span>
                        </button>
                      </div>
                      <div class="clearfix" v-if="billyapiupdate !== ''">
                        <b-alert size="lg" show variant="secondary">
                          <span>Sidste opdatering</span>:
                          <span>{{ moment(billyapiupdate).locale('da').format('LL') }}</span>
                        </b-alert>
                      </div>
                    </b-form>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- facebook -->
        <div class="col-6 px2 pt3 pl4">
          <p class="h5 regular darkblue line-height-golden mb3">
            <span class="primarycolor block mb1">Facebook integration</span>
            Med denne Facebook-integration bliver dine 4- og 5-stjernede anbefalinger automatisk postet på din Facebookside.
          </p>
          <b-img src="static/img/photo2.jpg" fluid-grow></b-img>
        </div>
        <div class="col-6 pr0 pl4">
          <div v-if="haaId !== '0'">
            <div class="clearfix mb2">
              <div class="col-12 px2 py2 flex justify-between items-center">
                <div v-b-toggle.details4 class="pointer flex justify-start items-center">
                  <img src="static/svg/facebook.svg" width="48">
                </div>
                <button class="outlined-dark-button gibson h6 px2 py1" v-if="help !== ''">
                  <span>Hjælp</span>
                </button>
              </div>
            </div>
            <div class="clearfix pb2">
              <div class="col-12 px2">
                <b-collapse visible id="details4">
                  <p class="h semi-bold line-height-2 my2">Facebook Integration</p>
                  <div show v-if="facebookapiupdate !== ''" class="clearfix darkblue-background white p2 mb2">
                    <p class="h5 gibson regular line-height-golden">
                      <span class="semi-bold block mb2">Tak! Din Facebook-konto er nu integreret med Håndværker.dk.</span>
                      Vi poster automatisk dine 4- og 5-stjernede anbefalinger på din Facebookside eller profil.
                    </p>
                  </div>
                  <div class="my2">
                    <button class="col-12 outlined-primary-button p2 gibson flex justify-center items-center line-height-1" @click="showModal('https://www.haandvaerker.dk/pdf/fb_integration.pdf#zoom=100')">
                      <span class="pr2 semi-bold">Hent vejledning her</span>
                      <span>
                        <i class="el-icon-right"></i>
                      </span>
                    </button>
                  </div>
                  <b-form class="py2" @submit.stop.prevent="service_facebook">
                    <b-form-group id="nameInput" label="Facebook Page-ID" label-for="navn">
                      <b-form-input id="navn" type="text" v-model="facebookpageid" required placeholder="" class="muted-background px2 py1 border-none darkblue h6 not-rounded" autocomplete="off"></b-form-input>
                    </b-form-group>
                    <div class="clearfix">
                      <b-button type="submit" @click="getdataigibilityfb('facebook','yes','https://www.kundematch.dk/newpartner/facebook.php?id='+salesPerson+'&levid='+haaId+'&pageid='+facebookpageid)"  class="col-12 facebook-button p2 h6 semi-bold not-rounded border-none">
                        <span class="fab fa-facebook mr-2"></span>
                        <span>Tilknyt Facebook</span>
                      </b-button>
                    </div>
                    <div class="clearfix" v-if="billyapiupdate !== ''">
                      <b-alert size="lg" show variant="secondary">
                        <span>Sidste opdatering</span>:
                        <span>{{ moment(billyapiupdate).locale('da').format('LL') }}</span>
                      </b-alert>
                    </div>
                  </b-form>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
     <b-modal  size="lg" ref="dinerowModal" centered id="modalPopover"  title="Hent vejledning her" ok-only>
        <b-col md="12" class="h-100 d-inline-block">
        <b-embed type="iframe" scrolling="no" :src="url" aspect="1by1"  allowfullscreen ></b-embed>
        </b-col>
        <div slot="modal-footer" class="py-4 px-4 d-flex justify-content-between w-100">
          <b-btn type="reset" variant="outline-dark" size="lg"  @click="hideModal" class="float-left">Luk
          </b-btn>
        </div>
      </b-modal>
    <noneligibleFeaturepop ref="noneligibleFeaturepop"></noneligibleFeaturepop>
    <haandvaerker></haandvaerker>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import hotlinemodal from './modals/HotlineModal'
import archivemodal from './modals/ArchiveModal'
import Haandvaerker from './haandvaerker'
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import Imentor from './imentor'
import noneligibleFeaturepop from './noneligibleFeaturepop'
export default {
  name: 'profilesettings',
  data () {
    return {
      apikey: '',
      apikeye: '',
      apikeyb: '',
      facebookpageid: '',
      help: '',
      pdf: '',
      dineroShow: false,
      facebookShow: true,
      facebookShowbox: true,
      items: [],
      loginOption: { scope: 'email,manage_pages,publish_pages' },
      optionsDistance: [],
      firmaid: '',
      partnertype: 'SMS-partner',
      dineroapiupdate: '',
      economicapiupdate: '',
      billyapiupdate: '',
      facebookapiupdate: '',
      show: false,
      imentor: true,
      label: 'Loading...',
      overlay: 1,
      haaId: '',
      url: '',
      salesPerson: '',
      eligible: ''
    }
  },
  computed: {
    facebookState () {
      return this.facebookpageid.length > 2
    }
  },
  components: {
    Imentor,
    Haandvaerker,
    hotlinemodal,
    archivemodal,
    loading,
    Simplert,
    noneligibleFeaturepop
  },
  created () {
    this.eligible = localStorage.getItem('PartnerAccountingInteg')
    this.eligiblefbrecommend = localStorage.getItem('FBPostRecommendation')
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.Reload()
    if (localStorage.getItem('imentor') === '0') {
      this.imentor = false
    }
  },
  methods: {
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1'}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.service_reminder = res.service_reminder
            this.partnertype = res.partnertype
            this.autobooking = res.autobooking
            this.inactivesms = res.inactivesms
            this.sms_size = res.sms_size
            this.dineroapiupdate = res.dineroapiupdate
            this.economicapiupdate = res.economicapiupdate
            this.billyapiupdate = res.billyapiupdate
            this.facebookapiupdate = res.facebookapiupdate
            this.firmaid = res.dinerofirma
            this.apikey = res.dineroapi
            this.apikeye = res.economicapi
            this.apikeyb = res.billyapi
            this.facebookpageid = res.facebookapi
          },
          response => {
            alert('error')
          }
        )
    },
    openUrl (url) {
      var win = window.open(url, '_blank')
      win.focus()
    },
    getUserData (log) {
      console.log(log)
      if (log['authResponse']['accessToken']) {
        this.show = true
        this.salesPerson = localStorage.getItem('id_token_portal')
        var dataPartner = {operation: 'service_facebook', salesPerson: this.salesPerson, token: log['authResponse']['accessToken'], userid: log['authResponse']['userID'], expire: log['authResponse']['data_access_expiration_time'], levid: this.haaId}
        this.$http.post('', dataPartner, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              this.show = false
              if (res.login === false) {
                this.$router.push('/login')
              }
              if (res.success) {
                this.modalShowDato = false
                let obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
                this.Reload()
              } else {
                alert(res.message)
              }
            },
            response => {
              alert('error')
            }
          )
      }
    },
    getConnectData (log) {
      this.facebookShow = true
    },
    service_dinero () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'service_dinero', salesPerson: this.salesPerson, firmaid: this.firmaid, apikey: this.apikey, levid: this.haaId}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.service_bitrix('dinero', this.apikey, this.firmaid)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    service_economic () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'service_economic', salesPerson: this.salesPerson, apikeye: this.apikeye, levid: this.haaId}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.service_bitrix('e-conomic', this.apikeye)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    service_billy () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'service_billy', salesPerson: this.salesPerson, apikeyb: this.apikeyb, levid: this.haaId}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.service_bitrix('billy', this.apikeyb)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    service_bitrix (type = '', value = '', firmaID = '') {
      var data1 = {
        supplierId: this.haaId,
        accessKey: value,
        integration: type
      }
      var data2 = {
        supplierId: this.haaId,
        accessKey: value,
        integration: type,
        organizationId: this.firmaid
      }
      var datafirma = firmaID !== '' ? data2 : data1
      this.$http.post(this.$bitrixapi + 'integration/saveSupplierIntegration', datafirma, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.modalShowDato = false
            if (type !== 'facebook') {
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            }
            this.Reload()
          } else {
            alert(res.message)
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    hideModal () {
      this.$refs.dinerowModal.hide()
    },
    showModal (pdf) {
      this.pdf = pdf
      this.url = pdf
      this.$refs.dinerowModal.show()
    },
    getdataigibility (intetype, submitted = 'yes') {
      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'PartnerAccountingInteg')
      } else {
        if (submitted === 'yes') {
          if (intetype === 'dinero') {
            this.service_dinero()
          } else if (intetype === 'economic') {
            this.service_economic()
          } else if (intetype === 'billy') {
            this.service_billy()
          }
        }
      }
    },
    getdataigibilityfb (intetype, submitted = 'yes', link = '') {
      if (this.eligiblefbrecommend === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'FBPostRecommendation')
      } else {
        if (submitted === 'yes') {
          if (intetype === 'facebook') {
            window.open(link, '_blank')
          }
        }
      }
    }
  }
}
</script>
<style scoped>
.modal-header,
.modal-footer {
  border-top: 0;
  border-bottom: 0;
}
.card-footer {
  border-top: 0;
  border-bottom: 0;
  background-color: #fff;
}
.switch-success > .switch-input:not(checked) ~ .switch-label {
  background: #CF000F;
  color: #fff;
  border: 0;
}
.switch-success > .switch-input:not(checked) ~ .switch-label::before {
  color: #fff!important;
}
.fa-exclamation-triangle {
  font-size: 26px;
}

.imglogo {
  width: 50%
}

.imglogof {
  width: 20%
}

.imglogoe {
  width: 85%
}

</style>



// WEBPACK FOOTER //
// integrationSettings.vue?e92f266e